import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  AadGroupPicker,
} from './AadGroupPickerExtension'
import { AadGroupPickerContributors } from './AadGroupPickerExtensionContributors';

export const AadGroupPickerFieldExtension: any = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AadGroupPicker',
    component: AadGroupPicker,
  },
))
export const AadGroupPickerFieldContributorExtension: any = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AadGroupPickerContributors',
    component: AadGroupPickerContributors,
  },
),
);
